
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../img/MainWebsite/WhiteLogoText.png';

function Header() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={'header green-background'}>
      <img className={'header-logo'} src={Image} alt="white logo text" />
      <nav className={'nav'}>
        <div className={` ${isMenuOpen ? 'display-none' : 'hamburger'}`} onClick={toggleMenu}>
          ☰
        </div>
        <div className={` ${isMenuOpen ? 'open ' : 'menu'}`}>
          <div className={'hamburger'} onClick={toggleMenu}>
            ☰
          </div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/">Home</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Golf">Golf</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Our-Menus">Our Menus</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/About-Us">About Us</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Contact-Us">Contact Us</Link></div>

          {/* <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Restaurants">Restaurants</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Hotels">Hotels</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Cruises">Cruises</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Dispensaries">Dispensaries</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Stores">Stores</Link></div>
          <div className={'header-option'}><Link className={'white-link bold no-underline'} to="/Venues">Venues</Link></div> */}
        </div>
      </nav>
    </header>
  );
}

export default Header;